import { getPartnerDataRequest } from '@/modules/request'

export async function getPartners () {
  let partners = {
    title: 'idsucc_nav_partners',
  }
  let partnerData = []
  const data = await getPartnerDataRequest(2)
  const sections = [...partnerData, ...data]
  return {
    ...partners,
    sections
  }
}

const navItem = {
  about: {
    text: 'idsucc_nav_about',
    href: '#about'
  },
  prizes: {
    text: 'idsucc_nav_prizes',
    href: '#prizes'
  },
  mentors: {
    text: 'idsucc_nav_mentors',
    href: '#tutors'
  },
  timeline: {
    text: 'idsucc_nav_timeline',
    href: '#timeline'
  },
  partner: {
    text: 'idsucc_nav_partners',
    href: '#partners'
  },
  faq: {
    text: 'idsucc_nav_faq',
    href: '#FAQ'
  },
  contact: {
    text: 'idsucc_nav_contact',
    href: '#contact'
  },
  careers: {
    text: 'idsucc_nav_careers',
    href: 'https://careers.shopee.co.id/',
    target: '_blank'
  },
}

const sighUpLink = "https://techatshopee.formstack.com/forms/succid2021";

const parnerStudentCommunities52_71 = [
  {
  name: 'idsucc_partner_52_1',
  image: require("@succ/public/images/partners/id/52 - Logo Himpunan Mahasiswa Manajemen Bisnis ITS.jpg"),
  link: 'https://www.instagram.com/bmsa_its/'
},
{
  name: 'idsucc_partner_54_1',
  image: require("@succ/public/images/partners/id/54 - IMAGAMA Logo.png"),
  link: 'https://imagama.feb.ugm.ac.id'
},
{
  name: 'idsucc_partner_55',
  image: require("@succ/public/images/partners/id/55 - Logo PPI Rotterdam.png"),
  link: 'https://ppi-rotterdam.nl'
},
{
  name: 'idsucc_partner_56',
  image: require("@succ/public/images/partners/id/56 - Logo PPI Groningen.png"),
  link: 'https://ppigroningen.nl/'
},
{
  name: 'idsucc_partner_57',
  image: require("@succ/public/images/partners/id/57 - Logo PPI Amsterdam.png"),
  link: 'https://ppiamsterdam.org'
},
{
  name: 'idsucc_partner_58',
  image: require("@succ/public/images/partners/id/58 - Logo PPI Belgia.png"),
  link: 'http://belgia.ppi.id/'
},
{
  name: 'idsucc_partner_59',
  image: require("@succ/public/images/partners/id/59 - LOGO KOSTAF PNG.png"),
  link: 'http://www.kostaffiaui.com'
},
{
  name: 'idsucc_partner_60',
  image: require("@succ/public/images/partners/id/60 - Logo-PPI-Delft.png"),
  link: 'http://ppidelft.net'
},
{
  name: 'idsucc_partner_61',
  image: require("@succ/public/images/partners/id/61 - PPI Swiss dan Liechstenstein.jpg"),
  link: 'https://pelajarindonesia.ch'
},
{
  name: 'idsucc_partner_63',
  image: require("@succ/public/images/partners/id/63 - logo ppia deakin.png"),
  link: 'https://www.ppiadeakin.com/'
},
{
  name: 'idsucc_partner_64',
  image: require("@succ/public/images/partners/id/64 - Logo PPIA RMIT.png"),
  link: 'https://www.ppia-rmit.com'
},
{
  name: 'idsucc_partner_65',
  image: require("@succ/public/images/partners/id/65 - PPI Prancis.jpg"),
  link: 'https://www.prancis.ppi.id'
},
{
  name: 'idsucc_partner_66',
  image: require("@succ/public/images/partners/id/66 - Logo PPI Belanda.png"),
  link: 'https://www.ppibelanda.org'
},
{
  name: 'idsucc_partner_67',
  image: require("@succ/public/images/partners/id/67 - PPIA Swinburne.png"),
  link: 'https://ppiaswinburne.org/'
},
{
  name: 'idsucc_partner_68',
  image: require("@succ/public/images/partners/id/68 - LOGO PPIA UNSW.png"),
  link: 'https://www.ppia.unsw.org'
},
{
  name: 'idsucc_partner_69',
  image: require("@succ/public/images/partners/id/69 - AIESEC UI LOGO BLUE.png"),
  link: 'https://www.instagram.com/aiesec_ui/?hl=en'
},
{
  name: 'idsucc_partner_71',
  image: require("@succ/public/images/partners/id/71_SwinburneSarawakIndonesianStudentAssociationSSISA.png"),
  link: 'https://www.instagram.com/ppiswinburne/'
},
];
const partnersUniversities_53_62_70 = [
{
  name: 'idsucc_partner_53_1',
  image: require("@succ/public/images/partners/id/53 - Logo UGM.jpg"),
  link: 'https://www.ugm.ac.id/'
},
{
  name: 'idsucc_partner_62',
  image: require("@succ/public/images/partners/id/62 - Logo UPH Career Center.png"),
  link: 'https://www.uph.edu/'
},
{
  name: 'idsucc_partner_70',
  image: require("@succ/public/images/partners/id/70 - Logo UI.png"),
  link: 'https://www.ui.ac.id/'
},
];

function message () {
  return {
    application: {
      title: 'Shopee Ultimate Case Challenge 2021',
      desc: 'The Shopee Ultimate Case Challenge is an annual business case competition designed to test the most inventive and innovative students with real-world problems. With the challenge’s unique mentorship program and multi-round format, you get to demonstrate your business acumen and resourcefulness with your team and create solutions that will make a difference in Southeast Asia, Taiwan, and beyond. If you’re ready to lead the way in the e-commerce and tech industry, prove it to the best of the best at the Shopee Ultimate Case Challenge!',
      startDate: '4 March 2021',
      endDate: '29 May 2021'
    },
    navbar: [
      navItem.about,
      navItem.prizes,
      navItem.mentors,
      navItem.timeline,
      navItem.partner,
      navItem.faq,
      navItem.contact,
      navItem.careers,
    ],
    banner: {
      registerBtn: 'idsucc_banner_sign_up',
      sighUpLink,
      explain: 'idsucc_banner_explain',
    },
    sighUpBtn: {
      sighUpLink,
      btnText: 'idsucc_banner_sign_up'
    },
    countDown: 'idsucc_countdown',
    about: {
      title: 'idsucc_about_title',
      desc: 'idsucc_about_content'
    },
    aim: {
      title: 'idsucc_title_objectives',
      list: [{
        desc: 'idsucc_objectives_text1',
        icon: require('@succ/public/images/aim/bg-1.svg')
      }, {
        desc: 'idsucc_objectives_text2',
        icon: require('@succ/public/images/aim/bg-2.svg')
      }, {
        desc: 'idsucc_objectives_text3',
        icon: require('@succ/public/images/aim/bg-3.svg')
      }],
      cardList: [{
        title: 'idsucc_objectives_list_title_1',
        desc: 'idsucc_objectives_list_desc_1',
        icon: require('@succ/public/images/aim/bg-4.svg')
      }, {
        title: 'idsucc_objectives_list_title_2',
        desc: 'idsucc_objectives_list_desc_2',
        icon: require('@succ/public/images/aim/bg-5.svg')
      }, {
        title: 'idsucc_objectives_list_title_3',
        desc: 'idsucc_objectives_list_desc_3',
        icon: require('@succ/public/images/aim/bg-6.svg')
      }, {
        title: 'idsucc_objectives_list_title_4',
        desc: 'idsucc_objectives_list_desc_4',
        icon: require('@succ/public/images/aim/bg-7.svg')
      }]
    },
    timeline: {
      title: 'idsucc_nav_timeline',
      list: [{
        date: 'idsucc_timeline_date_1',
        title: 'idsucc_timeline_title_1',
        desc: ['idsucc_timeline_desc_1']
      }, {
        date: 'idsucc_timeline_date_2',
        title: 'idsucc_timeline_title_2',
      }, {
        date: 'idsucc_timeline_date_3',
        title: 'idsucc_timeline_title_3',
        desc: 'idsucc_timeline_desc_3'
      }, {
        date: 'idsucc_timeline_date_4',
        title: 'idsucc_timeline_title_4',
        desc: ['idsucc_timeline_desc_4_01', 'idsucc_timeline_desc_4_02']
      }, {
        date: 'idsucc_timeline_date_5',
        title: 'idsucc_timeline_title_5',
        desc: ['idsucc_timeline_desc_5']
      }, {
        date: 'idsucc_timeline_date_6',
        title: 'idsucc_timeline_title_6',
        desc: ['idsucc_timeline_desc_6_01', 'idsucc_timeline_desc_6_02']
      }, {
        date: 'idsucc_timeline_date_7',
        title: 'idsucc_timeline_title_7',
        desc: ['idsucc_timeline_desc_7']
      }],
      explain: 'idsucc_timeline_explain'
    },
    tutors: {
      title: 'idsucc_mentors_title',
      list: [{
        image: require('@succ/public/images/tutors/tutor-id-1.jpg'),
        desc: 'idsucc_mentors_desc_1',
      }, {
        image: require('@succ/public/images/tutors/tutor-id-2.jpg'),
        desc: 'idsucc_mentors_desc_2',
      }, {
        image: require('@succ/public/images/tutors/tutor-id-3.jpg'),
        desc: 'idsucc_mentors_desc_3',
      }]
    },
    prizes: {
      title: 'idsucc_nav_prizes',
      desc: 'idsucc_prize_desc',
      list: [{
        title: 'idsucc_prize_title_1',
        money: 'idsucc_prize_money_1',
      }, {
        title: 'idsucc_prize_title_2',
        money: 'idsucc_prize_money_2',
      }, {
        title: 'idsucc_prize_title_3',
        money: 'idsucc_prize_money_3',
      }],
      full_width_list: [{
        image: require('@succ/public/images/prizes/team.svg'),
        title: 'idsucc_prize_title_4',
        money: 'idsucc_prize_money_4',
      }],
      explain: 'idsucc_prize_explain'
    },
    faqs: {
      title: 'idsucc_title_faqs',
      sections: [{
        title: 'idsucc_faq_title_about',
        list: [{
          question: 'idsucc_faq_about_q1',
          desc: ['idsucc_faq_about_a1']
        }, {
          question: 'idsucc_faq_about_q2',
          desc: ['idsucc_faq_about_a2']
        }, {
          question: 'idsucc_faq_about_q3',
          desc: [
            ['idsucc_faq_about_a3', { content: `<a href="#timeline">Timeline</a>`}]
          ]
        }, {
          question: 'idsucc_faq_about_q4',
          desc: ['idsucc_faq_about_a4']
        }, {
          question: 'idsucc_faq_about_q5',
          desc: [
            ['idsucc_faq_about_a5', { content: `<a href="pdf/id/succ-terms-and-conditions.pdf" target="_blank">Terms & Conditions / Privacy Policy</a>`}]
          ]
        }, {
          question: 'idsucc_faq_about_q6',
          desc: ['idsucc_faq_about_a6']
        }, {
          question: 'idsucc_faq_about_q7',
          desc: ['idsucc_faq_about_a7']
        }]
      }, {
        title: 'idsucc_faq_title_qualified',
        list: [{
          question: 'idsucc_faq_qualified_q1',
          desc: ['idsucc_faq_qualified_a1']
        }, {
          question: 'idsucc_faq_qualified_q2',
          desc: ['idsucc_faq_qualified_a2']
        }, {
          question: 'idsucc_faq_qualified_q3',
          desc: ['idsucc_faq_qualified_a3']
        }, {
          question: 'idsucc_faq_qualified_q4',
          desc: ['idsucc_faq_qualified_a4']
        }, {
          question: 'idsucc_faq_qualified_q5',
          desc: [
            ['idsucc_faq_qualified_a5', { content: `<a href="#question">Who can join</a>`}]
          ]
        }, {
          question: 'idsucc_faq_qualified_q6',
          desc: ['idsucc_faq_qualified_a6']
        }, {
          question: 'idsucc_faq_qualified_q7',
          desc: ['idsucc_faq_qualified_a7']
        }, {
          question: 'idsucc_faq_qualified_q8',
          desc: ['idsucc_faq_qualified_a8']
        }, {
          question: 'idsucc_faq_qualified_q9',
          desc: ['idsucc_faq_qualified_a9']
        }, {
          question: 'idsucc_faq_qualified_q10',
          desc: ['idsucc_faq_qualified_a10']
        }]
      }, {
        title: 'idsucc_faq_title_sign_up',
        list: [{
          question: 'idsucc_faq_sign_up_q1',
          desc: ['idsucc_faq_sign_up_a1']
        }, {
          question: 'idsucc_faq_sign_up_q2',
          desc: ['idsucc_faq_sign_up_a2']
        }, {
          question: 'idsucc_faq_sign_up_q3',
          desc: ['idsucc_faq_sign_up_a3']
        }, {
          question: 'idsucc_faq_sign_up_q4',
          desc: ['idsucc_faq_sign_up_a4']
        }, {
          question: 'idsucc_faq_sign_up_q5',
          desc: [
            ['idsucc_faq_sign_up_a5', { content: `<a href="#timeline">Timeline</a>`}]
          ]
        }, {
          question: 'idsucc_faq_sign_up_q6',
          desc: ['idsucc_faq_sign_up_a6']
        }]
      }, {
        title: 'idsucc_faq_title_tutor',
        list: [{
          question: 'idsucc_faq_tutor_q1',
          desc: ['idsucc_faq_tutor_a1']
        }, {
          question: 'idsucc_faq_tutor_q2',
          desc: ['idsucc_faq_tutor_a2']
        }, {
          question: 'idsucc_faq_tutor_q3',
          desc: ['idsucc_faq_tutor_a3']
        }]
      }, {
        title: 'idsucc_faq_title_inquiries',
        list: [{
          question: 'idsucc_faq_inquiries_q1',
          desc: ['idsucc_faq_inquiries_a1']
        }]
      }]
    },
    partners: {
      title: 'idsucc_nav_partners',
      sections: [{
        title: 'idsucc_host_title',
        justifyCenter: true,
        logos: [{
          name: 'idsucc_partner_shopee',
          image: require('@succ/public/images/partners/id/shopee.jpg'),
          link: 'https://careers.shopee.co.id',
          isShopee: true
        }]
      },
      {
        title: 'idsucc_universities_title',
        logos: [{
          name: 'idsucc_partner_1',
          image: require('@succ/public/images/partners/id/Institut Teknologi Bandung.png'),
          link: 'https://www.itb.ac.id/',
        }, {
          name: 'idsucc_partner_2',
          image: require('@succ/public/images/partners/id/Universitas Kristen Petra.png'),
          link: 'http://admission.petra.ac.id/',
        }, {
          name: 'idsucc_partner_15',
          image: require('@succ/public/images/partners/id/President University.png'),
          link: 'https://www.president.ac.id/',
        }, {
          name: 'idsucc_partner_25',
          image: require('@succ/public/images/partners/id/Logo IPMI.png'),
          link: 'https://ipmi.ac.id/',
        }, {
          name: 'idsucc_partner_26',
          image: require('@succ/public/images/partners/id/Universitas Airlangga.jpg'),
          link: 'https://www.unair.ac.id/',
        }, {
          name: 'idsucc_partner_29',
          image: require('@succ/public/images/partners/id/Universitas Multimedia Nusantara.jpg'),
          link: 'https://www.umn.ac.id/',
        }, {
          name: 'idsucc_partner_33',
          image: require('@succ/public/images/partners/id/LSPR.png'),
          link: 'http://www.lspr.edu/',
        }, {
          name: 'idsucc_partner_38',
          image: require('@succ/public/images/partners/id/Universitas Negeri Yogyakarta.png'),
          link: 'https://www.uny.ac.id/',
        }, ...partnersUniversities_53_62_70]
      }, {
        title: 'idsucc_student_communities_title',
        justifyCenter: true,
        logos: [{
          name: 'idsucc_partner_3',
          image: require('@succ/public/images/partners/id/Perhimpunan Mahasiswa Indonesia di CUHK (PEMICU).png'),
          link: 'https://pemicuhk.blogspot.com/'
        }, {
          name: 'idsucc_partner_4',
          image: require('@succ/public/images/partners/id/Permias San Francisco Bay Area.png'),
          link: 'https://www.instagram.com/permias.sfba/?hl=en'
        }, {
          name: 'idsucc_partner_5',
          image: require('@succ/public/images/partners/id/Cornell Indonesian Association.png'),
          link: 'https://www.instagram.com/indonesiaatcornell/?hl=en'
        }, {
          name: 'idsucc_partner_6',
          image: require('@succ/public/images/partners/id/Australian National University\'s Indonesian Students\' Association.png'),
          link: 'https://www.anuisa.com/'
        }, {
          name: 'idsucc_partner_7',
          image: require('@succ/public/images/partners/id/Perhimpunan Pelajar di Taiwan (PPI Taiwan).jpg'),
          link: 'https://www.instagram.com/ppitaiwan/'
        }, {
          name: 'idsucc_partner_8',
          image: require('@succ/public/images/partners/id/Persatuan Mahasiswa Indonesia di Amerika Serikat.png'),
          link: 'https://permiasnasional.com'
        }, {
          name: 'idsucc_partner_9',
          image: require('@succ/public/images/partners/id/PPI Edinburgh.jpg'),
          link: 'https://www.instagram.com/ppiedinburgh/'
        }, {
          name: 'idsucc_partner_10',
          image: require('@succ/public/images/partners/id/PPI Warwick.png'),
          link: 'https://www.instagram.com/ppiwarwick/'
        }, {
          name: 'idsucc_partner_11',
          image: require('@succ/public/images/partners/id/Gado-Gado Indonesian Students Association of UBC (GISAU).png'),
          link: 'https://www.gisaubc.com'
        }, {
          name: 'idsucc_partner_12',
          image: require('@succ/public/images/partners/id/Perhimpunan Pelajar Indonesia di Hong Kong (PPI HK)_Indonesian Students Association in Hong Kong.png'),
          link: 'https://www.instagram.com/ppihongkong/'
        }, {
          name: 'idsucc_partner_13',
          image: require('@succ/public/images/partners/id/PPIA University of Melbourne.png'),
          link: 'https://ppia-unimelb.org/'
        }, {
          name: 'idsucc_partner_14',
          image: require('@succ/public/images/partners/id/Imperial College Union Indonesian Society.png'),
          link: 'https://www.imperialcollegeunion.org/activities/a-to-z/filipino-society'
        }, {
          name: 'idsucc_partner_16',
          image: require('@succ/public/images/partners/id/Himpunan Mahasiswa Jurnalistik UNPAD.jpeg'),
          link: 'https://www.instagram.com/hmj_unpad/'
        }, {
          name: 'idsucc_partner_17',
          image: require('@succ/public/images/partners/id/SIBIRU by HMJ UNPAD.jpeg'),
          link: 'https://www.instagram.com/mediasibiru/'
        }, {
          name: 'idsucc_partner_18',
          image: require('@succ/public/images/partners/id/Himpunan Business Law BINUS.png'),
          link: 'https://www.instagram.com/binus_himslaw/'
        }, {
          name: 'idsucc_partner_19',
          image: require('@succ/public/images/partners/id/HMA Polinema.png'),
          link: 'http://hma.polinema.ac.id/'
        }, {
          name: 'idsucc_partner_20',
          image: require('@succ/public/images/partners/id/CEDS UI.jpg'),
          link: 'https://ceds.ui.ac.id'
        }, {
          name: 'idsucc_partner_21',
          image: require('@succ/public/images/partners/id/PERMIT Shanghai.png'),
          link: 'https://www.permitshanghai.com/'
        }, {
          name: 'idsucc_partner_22',
          image: require('@succ/public/images/partners/id/PERMIKA Vancouver.png'),
          link: 'https://permikavancouver.com'
        }, {
          name: 'idsucc_partner_23',
          image: require('@succ/public/images/partners/id/Himpunan Mahasiswa Manajemen (Universitas Islam Bandung).png'),
          link: 'https://www.instagram.com/himman_unisba/'
        }, {
          name: 'idsucc_partner_24',
          image: require('@succ/public/images/partners/id/HMAN PNJ.png'),
          link: 'https://www.instagram.com/hman_pnj/'
        }, {
          name: 'idsucc_partner_27',
          image: require('@succ/public/images/partners/id/SMUKI.png'),
          link: 'https://www.instagram.com/smu_ki/ '
        }, {
          name: 'idsucc_partner_28',
          image: require('@succ/public/images/partners/id/Binus English Club.png'),
          link: 'https://www.mybnec.org/'
        }, {
          name: 'idsucc_partner_30',
          image: require('@succ/public/images/partners/id/PPI Leeds.png'),
          link: 'https://www.ppigreaterleeds.com'
        }, {
          name: 'idsucc_partner_31',
          image: require('@succ/public/images/partners/id/Permias Bloomington.jpg'),
          link: 'https://permiasbloomington.wixsite.com/permiasbloomington'
        }, {
          name: 'idsucc_partner_32',
          image: require('@succ/public/images/partners/id/Himpunan Mahasiswa Ilmu Komunikasi (HIMNI) Universitas Pakuan.png'),
          link: 'https://www.instagram.com/himniunpak/'
        }, {
          name: 'idsucc_partner_34',
          image: require('@succ/public/images/partners/id/Himpunan Mahasiswa Manajemen (Universitas Trilogi).png'),
          link: 'https://www.instagram.com/himamen_trilogi/'
        }, {
          name: 'idsucc_partner_35',
          image: require('@succ/public/images/partners/id/Columbia Indonesian Society (ISUCI).jpg'),
          link: 'https://www.instagram.com/indouci/'
        }, {
          name: 'idsucc_partner_36',
          image: require('@succ/public/images/partners/id/HMPSA UNPAR.png'),
          link: 'https://www.instagram.com/hmpsa_unpar/'
        }, {
          name: 'idsucc_partner_37',
          image: require('@succ/public/images/partners/id/PADI Perhimpunan Mahasiswa SUTD Indonesia.png'),
          link: 'https://sutdindonesia.github.io/'
        }, {
          name: 'idsucc_partner_39',
          image: require('@succ/public/images/partners/id/Himpunan Mahasiswa Manajemen (Universitas Sumatera Utara).jpeg'),
          link: 'https://www.instagram.com/hmmfebusuofficial/'
        }, {
          name: 'idsucc_partner_40',
          image: require('@succ/public/images/partners/id/ISAFIS.png'),
          link: 'https://isafis.or.id/'
        }, {
          name: 'idsucc_partner_41',
          image: require('@succ/public/images/partners/id/UCLA.png'),
          link: 'https://www.instagram.com/uclaalumni.id/'
        }, {
          name: 'idsucc_partner_42',
          image: require('@succ/public/images/partners/id/HIMAKU Telkom.png'),
          link: 'https://www.instagram.com/himaku_telu/'
        }, {
          name: 'idsucc_partner_43',
          image: require('@succ/public/images/partners/id/PPI York.png'),
          link: 'https://www.instagram.com/ppiyork/'
        }, {
          name: 'idsucc_partner_44',
          image: require('@succ/public/images/partners/id/Indonesian Society Sheffield.png'),
          link: 'https://www.instagram.com/indosocsheffield/'
        }, {
          name: 'idsucc_partner_45',
          image: require('@succ/public/images/partners/id/PERMIT Beijing.jpeg'),
          link: 'https://www.permitbeijing.com'
        }, {
          name: 'idsucc_partner_46',
          image: require('@succ/public/images/partners/id/PPI Newcastle.png'),
          link: 'https://www.instagram.com/ppi_newcastleuk/'
        }, {
          name: 'idsucc_partner_47',
          image: require('@succ/public/images/partners/id/PPI Singapura.png'),
          link: 'https://www.ppisingapura.com/'
        },
        // {
        //   name: 'idsucc_partner_48',
        //   image: require('@succ/public/images/partners/id/HMM USU.jpg'),
        //   link: 'https://www.instagram.com/hmmfebusuofficial/'
        // },
        {
          name: 'idsucc_partner_49',
          image: require('@succ/public/images/partners/id/ISUCI.jpg'),
          link: 'https://www.instagram.com/indouci/'
        }, {
          name: 'idsucc_partner_50',
          image: require('@succ/public/images/partners/id/UW ISA.png'),
          link: 'https://www.instagram.com/uw_isa/'
        }, {
          name: 'idsucc_partner_51',
          image: require('@succ/public/images/partners/id/ISAUW.jpg'),
          link: 'https://www.instagram.com/isauwhuskies'
        },
        ...parnerStudentCommunities52_71,
        ],
      },
    ],
    },
    chance: {
      title: 'idsucc_title_chance',
      list: [{
        question: 'idsucc_chance_title_1',
        answers: ['idsucc_chance_desc_1_1', 'idsucc_chance_desc_1_2']
      }, {
        question: 'idsucc_chance_title_2',
        answers: ['idsucc_chance_desc_2_1', 'idsucc_chance_desc_2_2', 'idsucc_chance_desc_2_3', 'idsucc_chance_desc_2_4']
      }, {
        question: 'idsucc_chance_title_3',
        answers: ['idsucc_chance_desc_3_1', 'idsucc_chance_desc_3_2', 'idsucc_chance_desc_3_3']
      }],
      explain: 'idsucc_chance_explain'
    },
    contact: {
      desc: [
        'idsucc_contact_desc_1',
       ],
      btn: 'idsucc_contact_btn',
      btnLink: 'mailto:career.id@shopee.com'
    },
    footer: {
      logoStatic: true,
      follow: 'idsucc_follow_us',
      social: [{
        href: 'https://www.facebook.com/shopeecareers/',
        name: 'facebook',
        icon: require('@/assets/images/icon-facebook.svg')
      }, {
        href: 'https://www.instagram.com/LifeatShopee/',
        name: 'instagram',
        icon: require('@/assets/images/icon-instagram.svg')
      }, {
        href: 'https://linkedin.com/company/shopee',
        name: 'linkedin',
        icon: require('@/assets/images/icon-linkedin.svg')
      }],
      links: [[
        navItem.about,
        navItem.prizes,
        navItem.mentors,
      ], [
        navItem.timeline,
        navItem.partner,
        navItem.faq,
      ], [
        navItem.contact,
        navItem.careers
      ]],
      tc: 'pdf/id/succ-terms-and-conditions.pdf',
      privacyPolicy: 'pdf/id/succ-terms-and-conditions.pdf',
      copyright: 'Copyright © Shopee Limited. Trademarks belong to their respective owners. All rights reserved.'
    }
  }
}

export default message;
